import { CustomerController } from './customer.controller';
import { HttpService } from '@maia/httpClient';
import { ConfigService } from '@maia/config';
import {
  ActivityService,
  AttachmentService,
  ClaimService,
  CustomerService,
  InsuranceService,
  InvoiceService,
  NoteService,
  QuotationService,
  TaskService,
} from '@maia/shared';

export class ServiceFactory {
  private readonly configService = new ConfigService();
  private readonly httpService = new HttpService(this.configService, 'apiUrl');

  createCustomerController(): CustomerController {
    return new CustomerController(
      this.createCustomerService(),
      this.createClaimService(),
      this.createInsuranceService(),
      this.createInvoiceService(),
      this.createQuotationService(),
      this.createActivityService(),
      this.createNoteService(),
      this.createTaskService(),
      this.createAttachmentsService(),
    );
  }

  private createCustomerService(): CustomerService {
    return new CustomerService(this.httpService, this.configService);
  }

  private createClaimService(): ClaimService {
    return new ClaimService(this.httpService, this.configService);
  }

  private createInsuranceService(): InsuranceService {
    return new InsuranceService(this.httpService, this.configService);
  }

  private createInvoiceService(): InvoiceService {
    return new InvoiceService(this.httpService, this.configService);
  }

  private createQuotationService(): QuotationService {
    return new QuotationService(this.httpService, this.configService);
  }

  private createActivityService(): ActivityService {
    return new ActivityService(this.httpService, this.configService);
  }

  private createNoteService(): NoteService {
    return new NoteService(this.httpService, this.configService);
  }

  private createTaskService(): TaskService {
    return new TaskService(this.httpService, this.configService);
  }

  private createAttachmentsService(): AttachmentService {
    return new AttachmentService(this.httpService, this.configService);
  }
}

const factory = new ServiceFactory();
export const service = factory.createCustomerController();
